import { v4 } from 'uuid';

import { UploadArchiveResult } from './Archive.types';

import { UploadFile } from '@/components/_common';

export function getImgUrl(
  file: UploadFile<UploadArchiveResult>,
): string | undefined {
  if (file.response) {
    return file.response.filePath;
  }

  return file.url;
}

export function createUploadFileObj(
  imgUrl?: string,
): UploadFile<UploadArchiveResult> | undefined {
  if (!imgUrl) return undefined;

  const result: UploadFile<UploadArchiveResult> = {
    uid: v4(),
    name: imgUrl,
    url: imgUrl,
    status: 'done',
  };

  return result;
}
